import { HEADER_LABEL_URL_MAP } from '../consts';
import Entry from './Entry';
import Group from './Group';
import { CrossIcon, HomeIcon, GiftCardIcon } from 'assets/svg';
import { Role } from 'shared/consts/role';
import useScreenWidth from 'shared/hooks/useScreenWidth';
import { routeBuilder } from 'shared/router';
import { SCREENS } from 'tailwind/consts';

type Props = {
  onClose: () => void;
  onLogout: () => void;
};

function Navigation({ onClose, onLogout }: Props) {
  const screenWidth = useScreenWidth();
  const isMobileMenu = screenWidth < SCREENS.md;

  return (
    <div className="relative w-full h-full">
      <div className="absolute z-30 left-0 right-0 top-0 h-[56px] md:h-[60px] bg-palette-dark-brown flex p-4 w-full items-center justify-between">
        <span className="text-white tracking-tight font-semibold">Menu</span>
        <button onClick={onClose} className="flex">
          <CrossIcon className="h-4 w-4 flex-none text-white transition-transform hover:scale-125" />
        </button>
      </div>
      <div className="flex gap-6 flex-col w-full h-full pt-[80px] pb-8 px-4 overflow-auto scrollbar bg-white">
        <Entry icon={HomeIcon} label={HEADER_LABEL_URL_MAP.ROOT.label} to={routeBuilder.root()} onClose={onClose} />
        <Group label="Resources" rolesRequired={[Role.GC_View, Role.GC_Edit, Role.GC_Export]}>
          <div className="flex flex-col w-full gap-1.5">
            <Entry
              icon={GiftCardIcon}
              label={HEADER_LABEL_URL_MAP.GIFT_CARDS.label}
              to={routeBuilder.giftCards()}
              rolesRequired={[Role.GC_View, Role.GC_Edit, Role.GC_Export]}
              onClose={onClose}
            />
          </div>
        </Group>
        {isMobileMenu && (
          <button
            onClick={onLogout}
            className="flex w-full rounded-full border p-3 border-palette-color-border items-center justify-center"
          >
            <span className="uppercase tracking-tight text-palette-secondary">Logout</span>
          </button>
        )}
      </div>
    </div>
  );
}

export default Navigation;
